import { browser } from '$app/environment';
import { storable } from '$lib/utils/storable';

export const darkMode = storable('dark-mode', true);
export const isSidebarExpanded = storable('sidebar-expanded', 'expanded');

darkMode.subscribe((value) => {
  if (!browser) return;
  const body = document.querySelector('body');
  // Tailwind (`darkMode: 'class'`) reads `dark`; event-calendar reads `ec-dark`.
  body.classList.toggle('dark', value);
  body.classList.toggle('ec-dark', value);
});
